import {
	Box,
	Button,
	Card,
	CardBody,
	CardFooter,
	useBreakpoints,
} from "@sembark-travel/ui/base"
import { useXHR, XHRInstance } from "@sembark-travel/xhr"
import * as Validator from "yup"
import {
	Form,
	validateFormValues,
	withServerErrors,
	SubmissionError,
} from "@sembark-travel/ui/form"
import { useRef } from "react"
import { NewAndConfirmPasswordFields } from "./ResetPassword/NewAndConfirmPasswordFields"
import { passwordValidator } from "./ResetPassword/utils"

// schemas
export interface IResetPasswordCredentials {
	email: string
	token: string
	password: string
	password_confirmation: string
}
const resetPasswordSchema = Validator.object().shape({
	email: Validator.string()
		.required("Email field is required")
		.email("Invalid email address"),
	token: Validator.string().required(
		"Missing token to reset values. Please check for valid url from sent email"
	),
	password: passwordValidator,
	password_confirmation: Validator.string()
		.oneOf([Validator.ref("password")], "Passwords must match")
		.notRequired(),
})

// actions
function XHR(xhr: XHRInstance) {
	return {
		async resetPassword(data: IResetPasswordCredentials): Promise<void> {
			return xhr.delete("/passwords/reset", { data })
		},
	}
}

export function ResetPasswordForm({
	email,
	token,
	onSucess,
}: {
	email: string
	token: string
	onSucess: () => void
}) {
	const xhr = useXHR()
	const { xs } = useBreakpoints()
	const initialValues: IResetPasswordCredentials = useRef({
		email,
		token,
		password: "",
		password_confirmation: "",
	}).current
	return (
		<Form<IResetPasswordCredentials>
			initialValues={initialValues}
			validate={validateFormValues(resetPasswordSchema)}
			onSubmit={withServerErrors(async (values) => {
				await XHR(xhr).resetPassword(values)
				alert(
					"Your passwords updated successfully. You can now log in with the new password"
				)
				onSucess()
			})}
			subscription={{ submitting: true }}
		>
			{({ submitting, handleSubmit }) => (
				<form noValidate onSubmit={handleSubmit}>
					<SubmissionError />
					<Card style={{ width: xs ? "100%" : "30rem" }}>
						<CardBody>
							<input
								type="hidden"
								hidden
								name="email"
								value={initialValues.email}
							/>
							<input
								type="hidden"
								hidden
								value={initialValues.token}
								name="token"
							/>
							<NewAndConfirmPasswordFields
								conLabel="Confirm Password"
								newLabel="Password"
							/>
						</CardBody>
						<CardFooter>
							<Box>
								<Button type="submit" disabled={submitting}>
									{submitting ? "Resetting..." : "Reset Password"}
								</Button>
							</Box>
						</CardFooter>
					</Card>
				</form>
			)}
		</Form>
	)
}
